import React from 'react'
import PropTypes from 'prop-types'
import CourseMenuItem from './CourseMenuItem'
import MyCoursesHeader from './MyCoursesHeader'

const CoursesMenuSection = React.forwardRef((props, ref) => {
  return (
    <React.Fragment>
      {props.books.length > 0 ? <MyCoursesHeader name={props.section} /> : null}
      {props.books.map((book, i) => (
        <React.Fragment key={book.coursenum}>
          <CourseMenuItem
            ref={i === 0 ? ref : null}
            itemTitle={book.title}
            coursenum={book.coursenum}
            role={book.role}
            archived={book.status === 'archived'}
          />
        </React.Fragment>
      ))}
    </React.Fragment>
  )
})

CoursesMenuSection.displayName = 'CoursesMenuSection'

CoursesMenuSection.propTypes = {
  books: PropTypes.array,
  section: PropTypes.string,
  coursenum: PropTypes.string,
  published: PropTypes.bool,
  archived: PropTypes.bool,
  title: PropTypes.string,
  role: PropTypes.string,
}

export default CoursesMenuSection
